import { EQuizMode } from '@constants';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DescriptionWrapper,
  EmojiWrapper,
  InfoWrapper,
  ItemWrapper,
  TitleWrapper,
  Wrapper
} from './QuizModeSelector.styles';
type Props = {
  onSelect: (mode: EQuizMode) => void;
};

export const QuizModeSelector: React.FC<Props> = ({ onSelect }) => {
  const { t } = useTranslation('ManagerQuizzesTranslations');

  const items = useMemo(
    () => [
      {
        emoji: '🎯',
        title: t(EQuizMode.QUIZ),
        description: t(`${EQuizMode.QUIZ}_MODE_DESCRIPTION`),
        onClick: () => onSelect(EQuizMode.QUIZ),
        mode: EQuizMode.QUIZ
      },

      {
        emoji: '🏓',
        title: t(EQuizMode.TRUE_FALSE),
        description: t(`${EQuizMode.TRUE_FALSE}_MODE_DESCRIPTION`),
        onClick: () => onSelect(EQuizMode.TRUE_FALSE),
        mode: EQuizMode.TRUE_FALSE
      },
      {
        emoji: '⌛️',
        title: t(EQuizMode.PRACTICE),
        description: t(`${EQuizMode.PRACTICE}_MODE_DESCRIPTION`),
        onClick: () => onSelect(EQuizMode.PRACTICE),
        mode: EQuizMode.PRACTICE
      },
      {
        emoji: '📋',
        title: t(EQuizMode.PRACTICAL_CASE),
        description: t(`${EQuizMode.PRACTICAL_CASE}_MODE_DESCRIPTION`),
        onClick: () => onSelect(EQuizMode.PRACTICAL_CASE),
        mode: EQuizMode.PRACTICAL_CASE
      }
    ],
    []
  );

  return (
    <Wrapper>
      {items.map(item => (
        <ItemWrapper key={item.mode} onClick={() => onSelect(item.mode)}>
          <EmojiWrapper role="img" aria-label="Inspector">
            {item.emoji}
          </EmojiWrapper>
          <InfoWrapper>
            <TitleWrapper>{item.title}</TitleWrapper>
            <DescriptionWrapper>{item.description}</DescriptionWrapper>
          </InfoWrapper>
        </ItemWrapper>
      ))}
    </Wrapper>
  );
};
